import 'slick-carousel';

$('.js-brands').slick({
  lazyLoad: 'ondemand',
  infinite: true,
  autoplay: false,
  slidesToShow: 7,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

$('.c-hero__cog-slider').slick({
  infinite: true,
  autoplay: true,
  fade: true,
  slidesToShow: 1,
  arrows: false,
  dots: false,
  autoplaySpeed: 2000,
});

$('.js-next-cog-slide').on('click', function() {
  $('.c-hero__cog-slider').slick('slickNext');
});

$('.js-slider').slick({
  lazyLoad: 'ondemand',
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  arrows: true,
  dots: true,
});



// WEBPACK FOOTER //
// ./scripts/slick-slider.js